import { QueryObserver } from '@tanstack/react-query';
import { assign, sendParent } from 'xstate';
import { accountSummaryV2CacheKey, queryFnFactory } from '@syf-api-library/account-summary';
import fetchMachine from './fetchMachine';
const ASSIGN_ACTION = assign({
    accountSummaryQueryResult: ({ accountSummaryQueryResult }, event) => {
        const [, data] = event.data;
        return Object.assign(Object.assign({}, accountSummaryQueryResult), { data });
    }
});
export const sendSummarySuccessToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'AFTER_SUMMARY_FETCH' });
});
const accountSummary = {
    type: 'parallel',
    states: {
        querySubscription: {
            invoke: {
                src: ({ apiConfig, queryClient }) => {
                    const queryKey = accountSummaryV2CacheKey(apiConfig.keyProps);
                    const queryObserver = new QueryObserver(queryClient, {
                        queryKey,
                        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
                        enabled: false
                    });
                    const subscribe = (next) => {
                        const unsubscribe = queryObserver.subscribe((event) => {
                            if (event.isLoading === false && event.isSuccess === true) {
                                const data = [queryKey, event.data];
                                next({ type: 'SET_ACCOUNT_SUMMARY', data });
                            }
                        });
                        return {
                            unsubscribe
                        };
                    };
                    return {
                        subscribe
                    };
                }
            }
        },
        api: {
            initial: 'idle',
            states: {
                idle: {},
                fetching: {
                    invoke: {
                        src: fetchMachine,
                        data: {
                            // initialize fetchMachine with context values
                            cacheKey: ({ apiConfig }) => accountSummaryV2CacheKey(apiConfig.keyProps),
                            queryClient: ({ queryClient }) => queryClient,
                            queryFn: ({ apiConfig }) => queryFnFactory(apiConfig.config, apiConfig.keyProps)
                        },
                        onDone: {
                            target: 'success',
                            actions: ASSIGN_ACTION
                        },
                        onError: {
                            target: 'error',
                            actions: assign({
                                accountSummaryQueryResult: ({ accountSummaryQueryResult }, event) => {
                                    const [, error] = event.data;
                                    return Object.assign(Object.assign({}, accountSummaryQueryResult), { error });
                                }
                            })
                        }
                    },
                    on: {
                        FETCH_ACCOUNT_SUMMARY: undefined
                    }
                },
                success: {
                    entry: 'sendSummarySuccessToParent'
                },
                error: {
                    entry: 'sendErrorToParent'
                }
            }
        }
    },
    on: {
        FETCH_ACCOUNT_SUMMARY: {
            target: '#apiMachine.accountSummary.api.fetching',
            actions: ({ apiConfig, queryClient }, { force }) => {
                if (force) {
                    queryClient.invalidateQueries(accountSummaryV2CacheKey(apiConfig.keyProps));
                }
            }
        },
        SET_ACCOUNT_SUMMARY: {
            target: '#apiMachine.accountSummary.api.success',
            actions: ASSIGN_ACTION
        }
    }
};
export default accountSummary;
